module.exports = __webpack_public_path__ + "static/media/btn-new-chat-active.a7b5d8e3.svg";